<template>
  <v-list-item :to="route" color="primary">
    <v-list-item-icon class="px-0 mx-0">
      <v-icon v-text="icon" v-if="icon" />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title
        class="subtitle-2 ml-3 font-weight-regular"
        v-text="text"
      />
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    route: {
      type: String,
      required: true
    }
  }
};
</script>
